import axios from 'axios';

export default function loadCachedFonts() {
    return new Promise((resolve, reject) => {
        axios.get('/api/font-pairing/cache')
            .then(response => {
                resolve(response.data.data.cached);
            })
            .catch(() => {
                reject();
            });
    });
}
